import React from 'react';
import PropTypes from 'prop-types';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';

import AmountMetDisplay from '../AmountMetDisplay/AmountMetDisplay';
import PieChart from '../PieChart/PieChart';
import { monitaryFormat, removeStringCommas } from '../../../utils/format-utils';

const PlanStatusChart = ({
  amountMet,
  maxAmount,
  hasFamilyInPlan,
  color,
  title,
  metLabel,
  inlineTitle,
  ...rest
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const size = isMobile ? 150 : 200;

  return (
    <div {...rest}>
      {amountMet === maxAmount ? (
        <>
          <div>
            {hasFamilyInPlan && (
              <Typography>
                <b>Family</b>
              </Typography>
            )}
            <Typography>
              <b>{title}</b>
            </Typography>
          </div>
          <AmountMetDisplay label={metLabel} color={color} size={size} />
        </>
      ) : (
        <>
          <Typography
            style={{
              display: !inlineTitle && 'flex',
              flexDirection: !inlineTitle && 'column'
            }}
            color="textSecondary"
          >
            {hasFamilyInPlan && <b>Family</b>} <b>{title}</b>
          </Typography>
          <PieChart
            size={size}
            color={color}
            maxValue={maxAmount}
            value={amountMet}
            label={monitaryFormat(removeStringCommas(amountMet))}
            subLabel={`of ${monitaryFormat(removeStringCommas(maxAmount), {
              includeDecimal: false
            })}`}
            labelTestId={`${title}-chart-label`}
          />
        </>
      )}
    </div>
  );
};

PlanStatusChart.propTypes = {
  amountMet: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasFamilyInPlan: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  metLabel: PropTypes.string.isRequired,
  inlineTitle: PropTypes.bool
};

PlanStatusChart.defaultProps = {
  amountMet: 0,
  maxAmount: 0,
  inlineTitle: false
};

export default PlanStatusChart;
